import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [setIsScrolled]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/243999006868', '_blank');
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-lg shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl md:text-3xl font-bold">
              <span className={`bg-gradient-to-r from-amber-500 to-amber-600 bg-clip-text text-transparent transition-all ${
                isScrolled ? '' : 'text-white'
              }`}>
                GOS MÉDIA
              </span>
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a 
              href="#" 
              className={`font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Accueil
            </a>
            <a 
              href="#services" 
              onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}
              className={`font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Services
            </a>
            <a 
              href="#pricing" 
              onClick={(e) => { e.preventDefault(); scrollToSection('pricing'); }}
              className={`font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Tarifs
            </a>
            <a 
              href="#portfolio" 
              onClick={(e) => { e.preventDefault(); scrollToSection('portfolio'); }}
              className={`font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Portfolio
            </a>
            <a 
              href="#blog" 
              onClick={(e) => { e.preventDefault(); scrollToSection('blog'); }}
              className={`font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Blog
            </a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button
              onClick={openWhatsApp}
              className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white px-6 py-2 rounded-full font-semibold shadow-lg hover:scale-105 transition-transform"
            >
              <Phone className="mr-2 h-4 w-4" />
              Demander un Devis
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors ${
              isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
            }`}
          >
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-6 border-t border-gray-200">
            <nav className="flex flex-col gap-4">
              <a href="#" className="text-gray-700 hover:text-amber-600 font-medium py-2">
                Accueil
              </a>
              <a 
                href="#services" 
                onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}
                className="text-gray-700 hover:text-amber-600 font-medium py-2"
              >
                Services
              </a>
              <a 
                href="#pricing" 
                onClick={(e) => { e.preventDefault(); scrollToSection('pricing'); }}
                className="text-gray-700 hover:text-amber-600 font-medium py-2"
              >
                Tarifs
              </a>
              <a 
                href="#portfolio" 
                onClick={(e) => { e.preventDefault(); scrollToSection('portfolio'); }}
                className="text-gray-700 hover:text-amber-600 font-medium py-2"
              >
                Portfolio
              </a>
              <a 
                href="#blog" 
                onClick={(e) => { e.preventDefault(); scrollToSection('blog'); }}
                className="text-gray-700 hover:text-amber-600 font-medium py-2"
              >
                Blog
              </a>
              <Button
                onClick={() => {
                  openWhatsApp();
                  setIsMobileMenuOpen(false);
                }}
                className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white rounded-full font-semibold mt-4"
              >
                <Phone className="mr-2 h-4 w-4" />
                Demander un Devis
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
